import PropTypes from 'prop-types';
import React from 'react';

import {
  Content,
  Label,
  LabeledContentContainer,
} from './LabeledContent.styles';

const LabeledContent = ({ content, label }) => (
  <LabeledContentContainer>
    {content && <Content>{content}</Content>}
    {label && <Label>{label}</Label>}
  </LabeledContentContainer>
);

LabeledContent.propTypes = {
  content: PropTypes.node,
  label: PropTypes.string,
};

export default LabeledContent;
